const hasDoubleExtension = (filename, allowedTypes) => {
  const exts = allowedTypes.map(type => {
    const match = type.match(/image\/(.*)/);
    return match ? match[1] : null;
  }).filter(Boolean);

  const parts = filename.split('.');
  if (parts.length <= 2) return false; // "nom.ext"

  // Cas "nom.archive.tar.gz" (parts.length > 2)
  // Si la dernière extension est autorisée, mais il existe une extension juste avant, on bloque
  const lastExt = parts[parts.length - 1].toLowerCase();

  if (exts.includes(lastExt) && parts.length > 2) {
    return true;
  }
  return true;
};

const readBackgroundURL = (input) => {
  const file = input.files[0];
  const maxSize = 10485760; // 10 MB en octets
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/bmp']; // Types autorisés

  if (hasDoubleExtension(file.name, allowedTypes)) {
    alert("Le fichier sélectionné présente une double extension ou un nom non valide. Veuillez choisir un autre fichier.");
    input.value = "";
    return;
  }

  if (!allowedTypes.includes(file.type)) {
    alert("Veuillez sélectionner une image de type jpeg, jpg, png, webp, ou bmp.");
    input.value = ""; // Réinitialiser l'input
    return;
  }
  
  if (file.size > maxSize) {
    alert("La taille du fichier dépasse la limite de 10 MB. Veuillez choisir un autre fichier.");
    input.value = ""; // Réinitialiser l'input
  } else {
    const imagePreview = document.querySelector('#background_img_prev');
    const avatarImage = document.querySelector('#background-remove');
    imagePreview.style.display = "";
    if (document.querySelector('#background-remove')) {
      avatarImage.style.display ="none";
    }
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        $('#background_img_prev')
          .attr('src', e.target.result);
      };

      reader.readAsDataURL(input.files[0]);
    }
  }
}

export { readBackgroundURL };
